import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import moment from 'moment';


const mapLineToApiLineDto = (values: ICreateDataLineBillingForm , dataLineID:number): IPostNewDataLineBilling | {} => {
  let dataMapping: IPostNewDataLineBilling ;
  

    dataMapping = {
      dbDate: values.dbDate ? `${moment(values.dbDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null,
      billMonth: +values.billMonth,
      billYear: +values.billYear,
      dbDateFrom: values.dbDateFrom ? `${moment(values.dbDateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null,
      dbDateTo: values.dbDateTo ? `${moment(values.dbDateTo).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null,
      cost: +values.cost,
      lEnd: +values.lEnd,
      comLineID: dataLineID,
      deleted: false,
      description: "",
    }
  
  return dataMapping;
}


export const createDataLineBilling = ( {data, dataLineID} : {data: ICreateDataLineBillingForm, dataLineID:number }): Promise<string> => {
  const line = mapLineToApiLineDto(data,dataLineID);
  return axiosDefaultApi.post(`/api/Billing/InsertDataForDataLine`, line);
};

type QueryFnType = typeof createDataLineBilling;

type UseCreateDataLineBillingOptions = {
  data: IPostNewDataLineBilling | {};
  dataLineID: number;
  config?: MutationConfig<QueryFnType>;
};

export const useCreateDataLineBilling = ({ config, dataLineID }: UseCreateDataLineBillingOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία Νέου Ελέγχου.`, 500);
            console.error('Couldnt create new billing', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            console.log("dataLineID",dataLineID)
            queryClient.invalidateQueries([`getAllBillingsViaDataLineID_${dataLineID}`])
            addNotification(`Δημιουργήθηκε Νέος Έλεγχος.`, 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createDataLineBilling,
    })
}